const SDK_URL = {
  dev: {
    mobile: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.m.js',
    pc: 'https://dev-spi.naver.com/js/release/ko_KR/splugin.js'
  },
  real: {
    mobile: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.m.js',
    pc: 'https://ssl.pstatic.net/spi/js/release/ko_KR/splugin.js'
  }
};

export { SDK_URL };
